import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  Chip,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import PersonIcon from '@mui/icons-material/Person';
import { PhoneCall } from '../types';

// ============================================================================
// INCOMING CALL POPUP MODAL - Gelen Arama Popup
// ============================================================================

export interface IncomingCallPopupModalProps {
  open: boolean;
  incomingCall: PhoneCall | null;
  themeColor: string;
  onAnswer: () => void;
  onReject?: () => void;
}

const IncomingCallPopupModal: React.FC<IncomingCallPopupModalProps> = ({
  open,
  incomingCall,
  themeColor,
  onAnswer,
  onReject,
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        }
      }}
    >
      <Box
        sx={{
          bgcolor: '#4CAF50',
          color: 'white',
          p: 3,
          textAlign: 'center',
          animation: 'pulse 1.5s infinite',
          '@keyframes pulse': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0.7 },
            '100%': { opacity: 1 },
          },
        }}
      >
        <PhoneIcon sx={{ fontSize: 60, mb: 1 }} />
        <Typography variant="h4" fontWeight="bold">
          📞 GELEN ARAMA
        </Typography>
      </Box>
      
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h3" fontWeight="bold" sx={{ mb: 2, color: themeColor }}>
          {incomingCall?.phone || 'Bilinmeyen Numara'}
        </Typography>
        
        {incomingCall?.customerName ? (
          <Box sx={{ mb: 3 }}>
            <Chip 
              icon={<PersonIcon />}
              label={incomingCall.customerName}
              color="primary"
              sx={{ fontSize: '1.2rem', py: 2.5, px: 2 }}
            />
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              Kayıtlı Müşteri
            </Typography>
          </Box>
        ) : (
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Kayıtlı olmayan numara
          </Typography>
        )}
        
        <Typography variant="caption" color="text.secondary">
          Saat: {incomingCall?.time || '--:--'}
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 4, gap: 4 }}>
        {onReject && (
          <Button
            variant="contained"
            size="large"
            onClick={onReject}
            sx={{
              bgcolor: '#F44336',
              '&:hover': { bgcolor: '#D32F2F' },
              borderRadius: '50%',
              width: 100,
              height: 100,
              minWidth: 'unset',
              boxShadow: '0 4px 20px rgba(244, 67, 54, 0.4)',
            }}
          >
            <CallEndIcon sx={{ fontSize: 50 }} />
          </Button>
        )}
        <Button
          variant="contained"
          size="large"
          onClick={onAnswer}
          sx={{
            bgcolor: '#4CAF50',
            '&:hover': { bgcolor: '#388E3C' },
            borderRadius: '50%',
            width: 100,
            height: 100,
            minWidth: 'unset',
            boxShadow: '0 4px 20px rgba(76, 175, 80, 0.4)',
          }}
        >
          <CallIcon sx={{ fontSize: 50 }} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncomingCallPopupModal;
